import Api from "./PreApiHandler";
import { queryClient } from "@/plugins/vueQuery";

export default {
    getResourceUtm,
    resolveUtm,
    getDictionaries
};

async function getResourceUtm(params = {}, body) {
    const request = {
        method: 'post',
        path: 'report/dictionaries/get-utm',
        params,
        body
    }
    return queryClient.ensureQueryData({
        queryKey: ['dictionaries', 'get-utm', params, body],
        queryFn: () => Api.sendRequest(request),
    })
}

async function resolveUtm(params = {}, body) {
    const request = {
        method: 'post',
        path: 'report/dictionaries/resolve-utm',
        params,
        body
    }
    return queryClient.ensureQueryData({
        queryKey: ['dictionaries', 'resolve-utm', params, body],
        queryFn: () => Api.sendRequest(request),
    })
}

async function getDictionaries(params = {}, body) {
    const request = {
        method: 'post',
        path: 'report/dictionaries/get-dictionaries',
        params,
        body
    }
    return queryClient.ensureQueryData({
        queryKey: ['dictionaries', 'get-dictionaries', params, body],
        queryFn: () => Api.sendRequest(request),
    })
}